import { callGetApi, callPostApi, callPutApi } from "../interceptor";

// Login form API function
export async function userLogin(data) {
  try {
    const response = await callPostApi({ url: "users/sign_in", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}

// Logout API function
export async function logout() {
  try {
    const response = await callPostApi({ url: "users/sign_out" });
    return response;
  } catch (error) {
    throw error;
  }
}

// Forgot password API function
export async function forgotPasswordApi(data) {
  try {
    const response = await callPostApi({ url: "users/forgot_password", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}

// send reminder API function
export async function sendReminderApi(data) {
  try {
    const response = await callPostApi({ url: "users/send-reminder", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}

// Forgot password OTP API function
export async function forgotPasswordOtpApi(data) {
  try {
    const response = await callPostApi({ url: "users/forgot_password/otp", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}

// OTP verification API function
export async function otpVerificationApi(data) {
  try {
    const response = await callPostApi({ url: "users/otp_verification", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}

// Reset password With OTP API function
export async function resetPasswordApi(data) {
  try {
    const response = await callPutApi({
      url: "users/otp_verification/reset_password",
      body: data,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

// Get user profile API function
export async function getUserProfile() {
  try {
    const response = await callGetApi({ url: "users/get_profile" });
    return response;
  } catch (error) {
    throw error;
  }
}

// Update user profile API function
export async function userProfileUpdate(data) {
  try {
    const response = await callPutApi({ url: "users/update_profile", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function userProfileChangePassword(data) {
  try {
    const response = await callPostApi({ url: "users/change_password", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}

// SuperAdmin OTP verification API function
export async function superAdminOtpVerificationApi(data) {
  try {
    const response = await callPostApi({ url: "users/verify_otp", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}

// Resend SuperAdmin OTP API function
export async function resendSuperAdminOtpApi(data) {
  try {
    const response = await callPostApi({ url: "users/account/resend-otp", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}

// ==================== 2FA API Functions ====================

// Generate QR code for TOTP setup
export async function generateQRCodeApi() {
  try {
    const response = await callGetApi({ url: "users/account/generate-qrcode" });
    return response;
  } catch (error) {
    throw error;
  }
}

// Verify TOTP code
export async function verifyQRCodeApi(data) {
  try {
    const response = await callPostApi({ url: "users/account/verify-totp", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}

// Send verification code via email
export async function sendVerificationCodeApi(data) {
  try {
    const response = await callPostApi({ url: "users/account/send-email-verification", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}

// Verify email OTP
export async function verifyCodeApi(data) {
  try {
    const response = await callPostApi({ url: "users/account/verify-email-otp", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}

// ==================== TOTP Reset API Functions ====================

// Request TOTP Reset (Send Email)
export async function requestTotpResetApi(data) {
  try {
    const response = await callPostApi({ url: "users/account/request-totp-reset", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}

// Generate TOTP QR for Reset (Validate Token & Get QR)
export async function generateTotpQrResetApi(data) {
  try {
    const response = await callPostApi({ url: "users/account/generate-totp-qr-reset", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}

// Complete TOTP Reset (Verify new OTP)
export async function completeTotpResetApi(data) {
  try {
    const response = await callPostApi({ url: "users/account/complete-totp-reset", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}
